<header class="site-header">
  <nav>
    <div
      class="site-header__bar mx-auto flex max-w-[1680px] flex-wrap items-center justify-between gap-4 px-4 py-4 sm:px-6 lg:px-10"
    >
      <div class="flex items-center gap-4">
        <div class="header-logo-mark">
          <img
            src="images/logo_casadoc.svg"
            alt="Casa Doc"
            class="h-8 w-auto"
            title="v2.0.0"
          />
        </div>
      </div>

      @if (userService.user) {
        <div class="site-header__account flex items-center gap-3">
          @if (userService.user?.remainingAiImages !== undefined) {
            <span class="ai-credits">
              <span class="ai-credits__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"
                  />
                </svg>
              </span>
              <span>
                <strong>{{ userService?.user?.remainingAiImages }}</strong>
                crediti AI residui
              </span>
            </span>
          }
          <div class="user-chip">
            <span class="user-chip__name">{{ userDisplayName() }}</span>
            <button
              class="btn-outline-gray user-chip__logout"
              (click)="onSignOut()"
            >
              Logout
            </button>
          </div>
        </div>
      }
    </div>
  </nav>
</header>
